import React, { useState, useEffect, useMemo } from 'react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { getUploadedTime } from '../utils';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const ListofPush = ({ list }) => {
	const [rowData, setRowData] = useState([]);
	const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
	const gridStyle = useMemo(() => ({ height: '40vh' }), []);
	const defaultColDef = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
			resizable: true,
			sortable: true,
			filter: true,
		};
	}, []);

	const columnDefs = [
		{
			headerName: 'Alias Name',
			field: 'alias_name',
		},
		{ field: 'company_name', headerName: 'Company Name' },
		{ field: 'from_date', headerName: 'From Date' },
		{ field: 'to_date', headerName: 'To Date' },
		{ field: 'author_name', headerName: 'Pushed by' },
		{ field: 'status', headerName: 'Pipeline Status' },
		{ field: 'published_time', headerName: 'Pushed at' },
	];

	useEffect(
		() => {
			const rowResult = list.sort((a, b) => b.id - a.id).map(el => {
				return {
					alias_name: el.alias_name,
					company_name: el.company_name,
					to_date: el.to_date.split('T')[0],
					from_date: el.from_date.split('T')[0],
					author_name: el.author_name,
					status: el.status,
					published_time: getUploadedTime(el.published_time),
				};
			});
			setRowData(rowResult);
		},
		[list]
	);

	const gridOptions = {
		modules: AllModules,
		rowData,
		columnDefs,
		defaultColDef,
		pagination: true,
		paginationPageSize: 10,
	};

	return (
		<div style={containerStyle}>
			<AgGridTable gridOptions={gridOptions} gridStyle={gridStyle} />
		</div>
	);
};

export default ListofPush;
